module.exports = __webpack_public_path__ + "img/icon-gp-128x128-07-exclaim.a8be18be.svg";